import React from "react";
export const CogIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2502 2.68515L16.2101 6.12609C16.3648 6.2154 16.4601 6.38047 16.4601 6.5591V13.441C16.4601 13.6196 16.3648 13.7847 16.2101 13.874L10.2502 17.3149C10.0955 17.4042 9.90489 17.4042 9.75019 17.3149L3.79031 13.874C3.63561 13.7847 3.54031 13.6196 3.54031 13.441V6.5591C3.54031 6.38047 3.63561 6.21541 3.79031 6.12609L9.75019 2.68515C9.90489 2.59584 10.0955 2.59583 10.2502 2.68515ZM9.00019 1.38611C9.61899 1.02885 10.3814 1.02885 11.0002 1.38611L16.9601 4.82705C17.5789 5.18432 17.9601 5.84457 17.9601 6.5591V13.441C17.9601 14.1555 17.5789 14.8158 16.9601 15.173L11.0002 18.614C10.3814 18.9712 9.61899 18.9712 9.00019 18.614L3.04031 15.173C2.42151 14.8158 2.04031 14.1555 2.04031 13.441V6.5591C2.04031 5.84457 2.42151 5.18432 3.04031 4.82705L9.00019 1.38611ZM12.0055 9.99838C12.0055 11.1059 11.1077 12.0037 10.0002 12.0037C8.89262 12.0037 7.99479 11.1059 7.99479 9.99838C7.99479 8.89084 8.89262 7.99301 10.0002 7.99301C11.1077 7.99301 12.0055 8.89084 12.0055 9.99838Z"
      fill="#808192"
    />
  </svg>
);
